import { IconColors } from '../../notes/icon/icon.model';

export interface PreferenceObject {
  id: number;
  priority_number: number;
  short_name: string;
  detail_text: string;
}

export interface PreferenceRow extends PreferenceObject {
  available_option_ids: number[];
  user_selected_option_ids: number[];
}

export interface PreferenceColumn extends PreferenceObject {
  type: PreferenceOptionsType;
  disabled?: boolean;
}

export interface PreferenceData {
  id: number;
  display_text: string;
  is_enrolled: boolean;
  partner_name?: string;
  partner_terms_disclosure?: string;
  preference_group: string;
  preference_options: PreferenceColumn[];
  preference_types: PreferenceRow[];
  user_id?: string;
}

export interface CommStats {
  email_address: string;
  home_phone: string;
  cell_phone: string;
  office_phone: string;
}

export interface PreferenceGridConfig {
  data: PreferenceData;
  columns: PreferenceColumn[];
  rows: PreferenceRow[];
  isEditing: boolean;
  isEnrolled: boolean;
  commStats: CommStats;
  title: string;
  checkIcon?: string;
  fill?: IconColors;
  staticFill?: string;
}

export enum PreferenceOptionsType {
  exclusiveSelect = 'exclusive_select',
  multiSelect = 'multi_select',
}

export interface PreferenceGridArgs {
  config: PreferenceGridConfig;
  someOptionsSelected: boolean;
  someOptionsSelectedChange?: (value: Record<number, boolean>) => void;
  editedValue?: (value: PreferenceData) => void;
}
